import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Download from "./pages/Download";
import InviteLanding from "./pages/InviteLanding";
import MovieGenerator from "./pages/MovieGenerator";
import { generatorPages } from "./data/generatorPages";
import CollectionPage from "./pages/CollectionPage";
import { collections, collectionPath } from "./data/collections";
import FaqPage from "./pages/Faq";
import GuidesIndex from "./pages/Guides";
import GuideDetail from "./pages/GuideDetail";
import EsHome from "./pages/EsHome";
import PressKit from "./pages/PressKit";
import Pro from "./pages/Pro";
import SeoLanding from "./pages/SeoLanding";
import { landingPages } from "./data/landingPages";
import Hub from "./pages/Hub";
import { hubPages } from "./data/hubPages";
import CookieConsent from "./components/CookieConsent";
import ClientOnly from "./components/ClientOnly";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

/**
 * Everything below the router. The browser entry wraps this in a BrowserRouter;
 * the prerender entry wraps it in a StaticRouter.
 */
export const AppShell = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <ClientOnly>
        <Toaster />
        <Sonner />
      </ClientOnly>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/es" element={<EsHome />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/press" element={<PressKit />} />
        <Route path="/guides" element={<GuidesIndex />} />
        <Route path="/guides/:slug" element={<GuideDetail />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/download" element={<Download />} />
        {collections.map((c) => (
          <Route key={collectionPath(c)} path={collectionPath(c)} element={<CollectionPage slug={c.slug} lang={c.lang} />} />
        ))}
        {generatorPages.map((page) => (
          <Route key={page.path} path={page.path} element={<MovieGenerator path={page.path} />} />
        ))}
        {landingPages.map((page) => (
          <Route key={page.path} path={page.path} element={<SeoLanding path={page.path} />} />
        ))}
        {hubPages.map((hub) => (
          <Route key={hub.path} path={hub.path} element={<Hub path={hub.path} />} />
        ))}
        <Route path="/pro" element={<Pro />} />
        <Route path="/i" element={<InviteLanding />} />
        <Route path="/i/:handle" element={<InviteLanding />} />
        <Route path="/es/download" element={<Download lang="es" />} />
        <Route path="/es/guias" element={<GuidesIndex lang="es" />} />
        <Route path="/es/guias/:slug" element={<GuideDetail lang="es" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ClientOnly>
        <CookieConsent />
      </ClientOnly>
    </TooltipProvider>
  </QueryClientProvider>
);

const App = () => (
  <BrowserRouter>
    <AppShell />
  </BrowserRouter>
);

export default App;
